<!-- cart -->
<template>
    <div class="cart-box">
        <div class="divider-line"></div>
        <!-- 购物车列表 -->
        <div class="cart-list-box">
            <form @submit.prevent="payCart">
                <div class="cart-list">
                    <div class="scroll">
                        <div class="cart-item" v-for="(item,index) in goods_list" :key="index">
                            <input type="checkbox" :id="'cart' + item.goods_id" :value="item" v-model="selectList"
                                   @change="select"/>
                            <label :for="'cart' + item.goods_id">
                                <div :class="['iconfont', selectList.indexOf(item) != -1 ? 'icon-duihao' : '']"></div>
                            </label>
                            <div class="goods-dateil clearfix">
                                <div class="image-box" @click="toDetail(item.goods_id)">
                                    <img v-lazy="item.goods_image" class="skeleton-rect" width="80%"/>
                                </div>
                                <div class="content-box">
                                    <div class="title-box text-flow skeleton-rect">
                                        <div class="title" @click="toDetail(item.goods_id)">{{item.goods_name}}</div>
                                        <div class="sku-info">{{item.goods_sku.goods_attr}}</div>
                                        <div class="delete iconfont icon-shanchu"
                                             @click="cartDelete(item.goods_id,item.goods_sku_id)"></div>
                                    </div>
                                    <div class="price-box skeleton-rect">
                                        <div class="price">${{item.goods_price}}</div>
                                        <div class="goods-num-box">
                                            <div class="add-num iconfont icon-plus-bold"
                                                 @click="goodsAddNum(index)"></div>
                                            <div class="num-input">
                                                <input type="number" name="goods_num" :value="item.total_num" disabled/>
                                            </div>
                                            <div class="remove-num iconfont icon-minus-bold"
                                                 @click="goodsReomoveNum(index)"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- no-result -->
                        <div class="noresult" v-if="noresult">
                            <div class="cot">
                                <div class="img">
                                    <img src="../../assets/images/no_result.png"/>
                                </div>
                                <p class="text" style="color: #aaa">购物车是空的</p>
                                <router-link class="browse-btn" to="/">点击逛逛</router-link>
                            </div>
                        </div>
                        <!-- no-result end -->
                    </div>
                </div>
                <div class="cart-set-box" v-if="!noresult">
                    <div class="all-select" @click="allSelect">
                        <div :class="['iconfont', isSelect ? 'icon-duihao' : '']"></div>
                        全选
                    </div>
                    <div class="total-money">合计：
                        <div class="red">${{totalMoney}}</div>
                    </div>
                    <div class="submit-add">
                        <button class="submit" form-type="submit">去结算（{{totalNum}}）</button>
                    </div>
                </div>
            </form>
        </div>
        <nut-drag direction="y" :style="{right:'0px',bottom:'150px'}">
            <nut-fixednav active-text="收起导航" un-active-text="快速导航" :nav-list="NAVLIST" @selected="selectedNav"></nut-fixednav>
        </nut-drag>
    </div>
</template>
<script>
    import Util from '../../utils/util.js';
    import Tabber from '@/components/Tabber.vue'

    export default {
        name: 'GoodsCategory',
        components: {
            Tabber,
            Util
        },
        data() { //默认数据
            return {
                isSelect: false, //全部选中
                totalMoney: '0', //结算总金额
                totalNum: 0, //结算总数量
                isLogin: false,
                fav_money: '0', //优惠钱数
                noresult: true, //是否有数据
                goods_list: [],
                selectList: [], //选中列表
            }
        },
        created() { //视图加载前执行
            let _this = this;
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });

        },
        mounted() { //视图加载完成执行
            let _this = this;
            _this.isLogin = _this.checkIsLogin();
            _this.getCartList();
        },
        methods: {

            /**
             * 获取购物车列表
             */
            getCartList() {
                let _this = this;
                _this._get('cart/lists', {}, result => {
                    _this._initGoodsChecked(result.data);
                    _this.allSelect();
                    _this.loading.hide();
                });
            },

            /**
             * 初始化商品选中状态
             */
            _initGoodsChecked(data) {
                let _this = this;
                let checkedData = _this.getCheckedData();
                // 将商品设置选中
                data.goods_list.forEach(item => {
                    item.checked = Util.inArray(`${item.goods_id}_${item.goods_sku_id}`, checkedData);
                });
                if (!data.goods_list.length) {
                    _this.setData({
                        noresult: true
                    })
                } else {
                    _this.setData({
                        noresult: false
                    })
                }
                _this.goods_list = data.goods_list;
                _this.order_total_price = data.order_total_price;
                _this.action = 'complete';
                _this.checkedAll = checkedData.length == data.goods_list.length;
                // 更新购物车已选商品总价格
            },

            /**
             * 获取选中的商品
             */
            getCheckedData() {
                let checkedData = this.$ls.get('checkedData');
                return checkedData ? checkedData : [];
            },

            // 去商品详情
            toDetail(goods_id) {
                let _this = this;
                _this.navigationTo('/goods/show', {goods_id: goods_id});
            },


            /**
             * 结算
             */
            payCart: function (e) {
                let _this = this,
                    cartIds = _this.getCheckedIds();
                if (!cartIds.length) {
                    _this.$toast.warn('您还没有选择商品');
                    return false;
                }
                _this.navigationTo('/flow/checkout',{
                    order_type:'cart',
                    cart_ids: cartIds,
                })
            },

            /**
             *  全选
             */
            allSelect: function () {
                let _this = this,
                    totalMoney = 0;
                if (_this.isSelect) {
                    _this.selectList = [];
                    _this.isSelect = false;
                    _this.totalNum = 0;
                    _this.totalMoney = 0;
                } else {
                    _this.goods_list.forEach(function (item) {
                        totalMoney += parseFloat(item.goods_price) * item.total_num;
                    });
                    _this.selectList = _this.goods_list;
                    _this.isSelect = true;
                    _this.totalNum = _this.goods_list.length;
                    _this.totalMoney = totalMoney;
                }
            },

            // 单选切换
            select() {
                let _this = this,
                    totalMoney = 0;
                _this.selectList.forEach(function (item) {
                    totalMoney += parseFloat(item.goods_price) * item.total_num;
                });
                _this.isSelect = _this.selectList.length == _this.goods_list.length ? true : false;
                _this.totalNum = _this.selectList.length;
                _this.totalMoney = totalMoney;
            },

            /**
             * 购买数量加
             */
            goodsAddNum: function (index) {
                let _this = this;
                if (_this.goods_list[index].total_num < _this.goods_list[index].goods_sku.stock_num) {
                    _this.goods_list[index].total_num = ++_this.goods_list[index].total_num;
                    if (_this.selectList.indexOf(_this.goods_list[index]) != -1) {
                        _this.totalMoney = parseFloat(_this.totalMoney) + parseFloat(_this.goods_list[index].goods_price)
                    }
                    this.loading = this.$toast.loading('Loading...', {
                        coverColor: "rgba(0,0,0,0.5)",
                    });
                    _this._post_form('cart/add', {
                        goods_num: 1,
                        goods_id: _this.goods_list[index].goods_id,
                        goods_sku_id: _this.goods_list[index].goods_sku_id
                    }, () => {
                        _this.loading.hide();
                    });
                } else {
                    _this.$toast.warn('已超过最大购买数量');
                }
            },

            /**
             * 购买数量减
             */
            goodsReomoveNum: function (index) {
                let _this = this;
                if (_this.goods_list[index].total_num > 1) {
                    _this.goods_list[index].total_num = --_this.goods_list[index].total_num;
                    if(_this.selectList.indexOf(_this.goods_list[index]) != -1){
                        _this.totalMoney = parseFloat(_this.totalMoney) - parseFloat(_this.goods_list[index].goods_price);
                    }
                    this.loading = this.$toast.loading('Loading...', {
                        coverColor: "rgba(0,0,0,0.5)",
                    });
                    _this._post_form('cart/sub', {
                        goods_id: _this.goods_list[index].goods_id,
                        goods_sku_id: _this.goods_list[index].goods_sku_id
                    }, () => {
                        _this.loading.hide();
                    });
                }
            },

            /**
             * 获取已选中的商品
             */
            getCheckedIds() {
                let _this = this;
                let arrIds = [];
                _this.selectList.forEach(item => {
                    arrIds.push(`${item.goods_id}_${item.goods_sku_id}`);
                });
                return arrIds.join(',');
            },

            /**
             * 商品删除
             */
            cartDelete: function (goods_id, goods_sku_id) {
                let _this = this;
                let cartId = `${goods_id}_${goods_sku_id}`;
                _this.$dialog({
                    title: "您确定要移除这个商品吗?",
                    content: "删除后将从你的购物车里消失，无法找回",
                    okBtnTxt: "移除",
                    onOkBtn(event) {
                        _this._post_form('cart/delete', {
                            goods_sku_id: cartId
                        }, result => {
                            // 获取购物车列表
                            _this.getCartList();
                        });
                        this.close(); //关闭对话框
                    }
                });
            }
        },
        destroyed() {
            let _this = this;
            //切记页面销毁需要销毁
            _this.loading.hide();
        }
    }
</script>
<style lang="scss" scoped>
    @import "cart.scss";
</style>
